var React = require('react');

function CheckFilled (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_620_21557)","key":0},[React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"white","key":0}),React.createElement("path",{"d":"M5 9L7 11L12 6","stroke":"#111216","strokeWidth":"2","strokeLinecap":"square","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_620_21557"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

CheckFilled.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckFilled;

CheckFilled.default = CheckFilled;
